<template>
<div style="display:inline;">
  <el-button
    :size="size"
    :type="type"
    :icon="icon"
    :loading="loading"
    :disabled="disabled"
    v-show="isShow"
    @click="handleClick"
    v-if="label != 'qrcode'"
  >
    {{ label }}
  </el-button>
  <el-dropdown  split-button type="success" size="mini" v-if="label == 'qrcode'" @command="handleCommand" style="margin-right:6px;">
      生成二维码
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="1">临时轿车申报二维码</el-dropdown-item>
      <el-dropdown-item command="2">临时客车申报二维码</el-dropdown-item>
      <el-dropdown-item command="3">临时货车申报二维码</el-dropdown-item>
      <el-dropdown-item command="4">临时危化品申报二维码</el-dropdown-item>
      <el-dropdown-item command="5">临时人员申报二维码</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</div>
</template>

<script>
export default {
  name: 'HyPermButton',
  props: {
    label: {
      // 按钮显示文本
      type: String,
      default: 'Button'
    },
    icon: {
      // 按钮显示图标
      type: String,
      default: ''
    },
    size: {
      // 按钮尺寸
      type: String,
      default: 'mini'
    },
    type: {
      // 按钮类型
      type: String,
      default: null
    },
    isShow: {
      // 是否显示
      type: Boolean,
      default: true
    },
    loading: {
      // 按钮加载标识
      type: Boolean,
      default: false
    },
    disabled: {
      // 按钮是否禁用
      type: Boolean,
      default: false
    },
    perms: {
      // 按钮权限标识，外部使用者传入
      type: [String, Number],
      default: null
    }
  },
  methods: {
    handleClick: function () {
      // 按钮操作处理函数
      this.$emit('click', {});
    },
    handleCommand(command) {
      this.$emit('command', {command:command});
    },
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/HyPermButton.vue